var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptimise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "728px",
    height: "637px",
    viewBox: "0 0 728 637",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphical elements / illustration / optimise") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphical-elements-/-illustration-/-optimise",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.02601,84 C42.5206149,84.0016534 41.29901,85.2216049 41.29901,86.727 L41.29901,179.739 C41.29901,181.244395 42.5206149,182.464347 44.02601,182.466 L361.18201,182.466 C362.687405,182.464347 363.90901,181.244395 363.90901,179.739 L363.90901,86.727 C363.90901,85.2216049 362.687405,84.0016534 361.18201,84 L44.02601,84 Z",
    id: "a9fff5a8-4449-4722-8691-2681997674a8-172",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "ef08fdaa-4829-440e-93ff-da8e736c3be7-173",
    fill: "#F3F3F3",
    fillRule: "nonzero",
    points: "48.132 175.633 357.074 175.633 357.074 90.833 48.132 90.833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.07805,158.04 C316.464103,158.04 314.972754,158.90103 314.16578,160.29875 C313.358806,161.696469 313.358806,163.418531 314.16578,164.81625 C314.972754,166.21397 316.464103,167.075 318.07805,167.075 L336.14705,167.075 C338.641996,167.075 340.66455,165.052446 340.66455,162.5575 C340.66455,160.062554 338.641996,158.04 336.14705,158.04 L318.07805,158.04 Z",
    id: "f7452840-914d-46a1-ae61-ea1c2fc2d2a5-174",
    fill: "#C9B181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b2c9f911-15af-4e19-9f72-89a224d6cf2b",
    fill: "#E6E6E6",
    fillRule: "nonzero",
    x: 132.07703,
    y: 149.27804,
    width: 208.58798,
    height: 1.189
  }), /*#__PURE__*/React.createElement("circle", {
    id: "a570d7cb-c53f-47e1-9372-81d6b1f4b9cc",
    fill: "#19222F",
    fillRule: "nonzero",
    cx: 88.476,
    cy: 133.23303,
    r: 26.311
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "a3321d5c-167e-43b0-8c0e-18df1c8c5ae5-175",
    fill: "#3F3D56",
    fillRule: "nonzero",
    points: "132.40901 142.641 131.75001 141.652 153.42501 127.202 168.28801 134.337 189.66701 120.678 189.95601 120.801 232.19601 138.82 266.06301 122.183 298.95001 135.516 340.27301 143.916 341.06101 144.806 299.18601 136.895 266.10901 123.484 232.22901 140.126 189.77701 122.017 168.36901 135.694 153.51901 128.566"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.93998,158.663 C133.831009,158.696935 132.139131,160.416256 132.139131,162.5255 C132.139131,164.634744 133.831009,166.354065 135.93998,166.388 L176.34998,166.388 C178.481274,166.419427 180.235256,164.718622 180.269439,162.58737 C180.303622,160.456118 178.605086,158.699938 176.47388,158.663 C176.43262,158.662333 176.39132,158.662333 176.34998,158.663 L135.93998,158.663 Z",
    id: "f7b9bcea-10c4-4c80-b4a6-3d8e323f573e-176",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.05937,132.90625 C98.4431874,132.290022 97.4441223,132.289982 96.82789,132.90616 L96.8278,132.90625 L90.05394,139.68 L90.05394,122.97649 C90.0467066,122.110156 89.3423596,121.411665 88.475995,121.411665 C87.6096304,121.411665 86.9052834,122.110156 86.89805,122.97649 L86.89805,139.68 L80.12419,132.9062 C79.5091296,132.290812 78.5120091,132.289398 77.8952058,132.903039 C77.2784025,133.51668 77.2746914,134.513795 77.88691,135.13201 L77.89262,135.1377 L87.36021,144.60529 C87.9764506,145.221498 88.9755394,145.221498 89.59178,144.60529 L99.05937,135.1377 C99.6755532,134.521496 99.6755532,133.522454 99.05937,132.90625 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.80098,232.963 C167.295585,232.964653 166.07398,234.184605 166.07398,235.69 L166.07398,328.702 C166.07398,330.207395 167.295585,331.427347 168.80098,331.429 L485.95798,331.429 C487.463375,331.427347 488.68498,330.207395 488.68498,328.702 L488.68498,235.69 C488.68498,234.184605 487.463375,232.964653 485.95798,232.963 L168.80098,232.963 Z",
    id: "f7c5b60e-33a7-4042-9d2c-5c8c9116b84c-177",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "a8273e4e-93d2-47bb-9b17-df51a96534af-178",
    fill: "#F5F5F5",
    fillRule: "nonzero",
    points: "172.908 324.596 481.851 324.596 481.851 239.796 172.908 239.796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.85399,307.005 C440.359044,307.005 438.33649,309.027554 438.33649,311.5225 C438.33649,314.017446 440.359044,316.04 442.85399,316.04 L460.92106,316.04 C463.416006,316.04 465.43856,314.017446 465.43856,311.5225 C465.43856,309.027554 463.416006,307.005 460.92106,307.005 L442.85399,307.005 Z",
    id: "a87d1795-16f3-4774-9768-c375c1bdbb9e-179",
    fill: "#C9B181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b60d1a48-178f-4eb5-a9a3-9e4316169c72",
    fill: "#E6E6E6",
    fillRule: "nonzero",
    x: 256.853,
    y: 298.24204,
    width: 208.58801,
    height: 1.189
  }), /*#__PURE__*/React.createElement("circle", {
    id: "f066d7d6-19fd-468d-830f-1318b53822b2",
    fill: "#C9B181",
    fillRule: "nonzero",
    cx: 213.25099,
    cy: 282.19703,
    r: 26.311
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "fcead4ff-5625-4c61-90c0-6a9c2def1900-180",
    fill: "#3F3D56",
    fillRule: "nonzero",
    points: "257.183 291.605 256.523 290.616 278.198 276.166 293.062 283.301 314.441 269.642 314.73 269.765 356.969 287.784 390.837 271.147 423.724 284.479 465.047 247.879 465.835 248.769 423.95988 285.855 390.88288 272.445 357.00388 289.087 314.55188 270.978 293.14398 284.655 278.29798 277.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.71599,307.626 C258.58279,307.591261 256.825329,309.2924 256.79059,311.4256 C256.755851,313.5588 258.45699,315.316261 260.59019,315.351 L260.59019,315.351 C260.63215,315.351667 260.674083,315.351667 260.71599,315.351 L301.12599,315.351 C303.234961,315.317065 304.926839,313.597744 304.926839,311.4885 C304.926839,309.379256 303.234961,307.659935 301.12599,307.626 L260.71599,307.626 Z",
    id: "b25442e4-8332-4a87-9c30-01930e0b437c-181",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.66761,282.5238 C202.963507,282.819729 203.364844,282.985992 203.783329,282.986011 C204.201814,282.986029 204.603166,282.819803 204.89909,282.5239 L204.89918,282.5238 L211.67305,275.75 L211.67305,292.45355 C211.67305,293.325022 212.379518,294.03149 213.25099,294.03149 C214.122462,294.03149 214.82893,293.325022 214.82893,292.45355 L214.82893,275.75 L221.6028,282.5238 C222.001409,282.92248 222.582439,283.078206 223.127003,282.932313 C223.671567,282.78642 224.096924,282.361074 224.242832,281.816514 C224.388739,281.271954 224.233029,280.69092 223.83436,280.2923 L214.36677,270.82471 C213.750531,270.208509 212.751449,270.208509 212.13521,270.82471 L202.66761,280.2923 C202.051399,280.908512 202.051399,281.907588 202.66761,282.5238 L202.66761,282.5238 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.727,381.927 C1.22160487,381.928653 3.69482223e-13,383.148605 3.69482223e-13,384.654 L3.69482223e-13,477.666 C3.69482223e-13,479.171395 1.22160487,480.391347 2.727,480.393 L319.883,480.393 C321.388395,480.391347 322.61,479.171395 322.61,477.666 L322.61,384.654 C322.61,383.148605 321.388395,381.928653 319.883,381.927 L2.727,381.927 Z",
    id: "f3e6157c-e0fb-4525-9ebd-9efe95b1618f-182",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "b96defd0-9a2c-4c45-aa8c-b5fd1840c319-183",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "6.834 473.56 315.777 473.56 315.777 388.76 6.834 388.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.779,455.968 C274.284054,455.968 272.261501,457.990554 272.261501,460.4855 C272.261501,462.980446 274.284054,465.003 276.779,465.003 L294.848,465.003 C297.342946,465.003 299.3655,462.980446 299.3655,460.4855 C299.3655,457.990554 297.342946,455.968 294.848,455.968 L276.779,455.968 Z",
    id: "a2204f79-048d-45a5-9dbf-3ca685e385ac-184",
    fill: "#C9B181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ece8f467-8c57-41a5-b787-946f11f73852",
    fill: "#E6E6E6",
    fillRule: "nonzero",
    x: 90.77801,
    y: 447.20604,
    width: 208.58799,
    height: 1.189
  }), /*#__PURE__*/React.createElement("circle", {
    id: "acd23665-8915-4d62-9edc-4433a6bf124b",
    fill: "#C9B181",
    fillRule: "nonzero",
    cx: 47.17702,
    cy: 431.16005,
    r: 26.311
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "b2ebcab4-d8cf-428d-87b9-c73daac40ac9-185",
    fill: "#3F3D56",
    fillRule: "nonzero",
    points: "91.10801 440.569 90.44901 439.58 112.12401 425.129 126.98701 432.264 148.36701 418.601 190.89501 436.742 224.76201 420.105 257.64501 433.442 298.96801 416.842 299.75601 417.732 257.88601 434.82092 224.80901 421.41092 190.93001 438.05292 148.47801 419.94392 127.07101 433.62192 112.22101 426.49392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.641,456.589 C92.5320293,456.622935 90.840151,458.342256 90.840151,460.4515 C90.840151,462.560744 92.5320293,464.280065 94.641,464.314 L135.051,464.314 C136.430938,464.33647 137.718042,463.621045 138.427471,462.437219 C139.1369,461.253392 139.160875,459.781015 138.490366,458.574719 C137.819856,457.368422 136.556728,456.61147 135.17679,456.589 C135.134863,456.588333 135.092933,456.588333 135.051,456.589 L94.641,456.589 Z",
    id: "aca123b7-0fc2-4f3d-89c1-779a89955e8d-186",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.59364,431.48682 C36.8895401,431.782746 37.2908773,431.949005 37.7093614,431.949022 C38.1278454,431.949038 38.529196,431.782812 38.82512,431.48691 L38.82521,431.48682 L45.59907,424.71301 L45.59907,441.41657 C45.60298,442.283318 46.3052513,442.984669 47.1720038,442.987452 C48.0387563,442.990217 48.7455023,442.293375 48.75496,441.42667 L48.75496,424.713 L55.52882,431.48681 C56.1434577,432.104618 57.1425521,432.107187 57.7603598,431.49255 C58.3781676,430.877912 58.3807375,429.878818 57.7661,429.26101 L57.76039,429.2553 L48.2928,419.78771 C47.6765594,419.171502 46.6774706,419.171502 46.06123,419.78771 L36.59364,429.2553 C36.2977213,429.551218 36.1314759,429.952569 36.1314759,430.37106 C36.1314759,430.789551 36.2977213,431.190902 36.59364,431.48682 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB7B7",
    fillRule: "nonzero",
    points: "650.421 621.96302 635.192 621.96202 627.948 563.22502 650.423 563.22602"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.30429,636.72459 L605.20206,636.72277 L605.20206,636.1017 C605.202806,625.546799 613.759159,616.990602 624.31406,616.99005 L624.31527,616.99005 L654.30527,616.99126 L654.30429,636.72459 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB7B7",
    fillRule: "nonzero",
    points: "594.525 621.96302 579.297 621.96202 572.052 563.22502 594.528 563.22602"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.40856,636.72459 L549.30633,636.72277 L549.30633,636.1017 C549.307076,625.546799 557.863429,616.990602 568.41833,616.99005 L568.41954,616.99005 L598.40954,616.99126 L598.40856,636.72459 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.82256,431.4459 C568.49243,429.265661 570.059466,426.014818 570.102011,422.568104 C570.144556,419.121389 568.658241,415.832857 566.043,413.58738 L574.3201,388.29081 L560.17424,379.51148 L548.98706,415.39931 C545.427777,420.147035 545.982086,426.806568 550.277311,430.900518 C554.572536,434.994469 561.250989,435.228773 565.82256,431.4459 L565.82256,431.4459 Z",
    id: "Path",
    fill: "#FFB7B7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.91256,414.74636 C580.91256,414.74636 566.69867,491.68766 566.87593,506.62248 C567.08983,524.64506 575.10908,601.88567 575.10908,601.88567 L595.526,596.78145 L599.38513,507.25529 L615.53279,450.11744 L621.74342,523.40294 L627.97777,600.49306 L651.66336,600.49306 L656.96856,407.09 L579.63646,404.5379 L580.91256,414.74636 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.73369,259.70541 L610.89986,260.98141 L585.37872,419.21251 C585.37872,419.21251 639.61115,444.09562 662.58018,426.23082 C685.54921,408.36602 651.73369,259.70541 651.73369,259.70541 Z",
    id: "Path",
    fill: "#CBCBCB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.64212,293.52092 L582.18856,491.30979 L560.49556,484.9295 L575.80825,413.4703 L583.46459,342.0111 L582.18856,270.55189 L608.98576,259.06738 L616.64211,250.13498 C616.64211,250.13498 631.9548,269.27584 616.64212,293.52092 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.50692,288.693 L637.05903,496.414 L689.37738,487.4816 L685.54921,294.797 L690.65344,267.9998 L665.13229,256.51528 L654.79824,250.135 C654.79824,250.135 631.9548,257.06789 634.50692,288.693 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero",
    points: "593.673 274.38002 582.189 270.55202 565.6 344.56302 551.563 403.26202 571.98 407.09002 591.121 343.28702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.71743,443.86717 C706.04756,441.686931 704.480524,438.436088 704.437979,434.989374 C704.395434,431.542659 705.881749,428.254127 708.49699,426.00865 L700.21989,400.71208 L714.36575,391.93275 L725.55288,427.82058 C729.112073,432.568299 728.557736,439.227751 724.26256,443.321668 C719.967384,447.415584 713.289011,447.649939 708.71743,443.86717 L708.71743,443.86717 Z",
    id: "Path",
    fill: "#FFB7B7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero",
    points: "679.625 271.89602 691.109 268.06802 707.698 342.07902 722.977 415.68302 699.997 419.06402 682.177 340.80302"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB7B7",
    fillRule: "nonzero",
    transform: "translate(634.119271, 214.811860) rotate(-28.663220) translate(-634.119271, -214.811860) ",
    cx: 634.119271,
    cy: 214.81186,
    r: 28.36217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.22947,177.6987 C651.34293,169.87992 659.03912,192.3523 659.03912,192.3523 C672.10831,201.0229 663.92592,211.89366 663.92592,211.89366 C667.2236,212.62617 660.63003,231.92413 658.43137,231.43577 C657.25828,231.17512 654.24162,234.77601 651.68309,238.19099 C650.805752,238.189864 649.93038,238.274006 649.06932,238.44223 L654.03346,220.07747 C654.03346,220.07747 637.30075,217.51394 632.17055,209.45332 C627.26225,201.7416 611.10443,199.30686 606.50613,204.45797 C606.234291,202.976925 605.677349,201.562785 604.86625,200.29412 C604.238338,199.330352 603.417387,198.507269 602.45525,197.87686 C606.52077,180.59948 624.22947,177.6987 624.22947,177.6987 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimise);
export default __webpack_public_path__ + "static/media/optimise.f0b8553cc460335197214bde56443cc0.svg";
export { ForwardRef as ReactComponent };